import type { FC } from "react";
import { ChatAttachmentFile } from "web_myplann/Chat/Components/ChatAttachmentFile";
import { ChatAttachmentImage } from "web_myplann/Chat/Components/ChatAttachmentImage";
import { getChatAttachmentKey } from "web_myplann/Chat/Helpers/getChatAttachmentKey";
import type { ChatAttachmentView } from "web_myplann/Chat/Types/chatMessage";

type FileStyle = {
	backgroundColor: string;
	color?: string;
	boxShadow?: string;
};

type Props = {
	attachments: ChatAttachmentView[];
	fileStyle: FileStyle;
};

export const ChatMessageAttachments: FC<Props> = ({
	attachments,
	fileStyle,
}) => (
	<>
		{attachments.map((attachment, index) =>
			attachment.isImage ? (
				<ChatAttachmentImage
					key={getChatAttachmentKey(attachment, index)}
					attachmentId={attachment.id}
					fileName={attachment.fileName}
					localUrl={attachment.localUrl}
				/>
			) : (
				<ChatAttachmentFile
					key={getChatAttachmentKey(attachment, index)}
					fileName={attachment.fileName}
					{...fileStyle}
				/>
			),
		)}
	</>
);
